import { render, staticRenderFns } from "./NewHub.pug?vue&type=template&id=3707eba6&external"
import script from "./NewHub.js?vue&type=script&lang=js&external"
export * from "./NewHub.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports